export default "__VITE_ASSET__aEODRF7H__"